import loadable from '@loadable/component';

export const SheerLuxeSiteWrapper = loadable(
  () => import(/* webpackChunkName: "sheerluxe-site" */ './SheerLuxeSiteWrapper'),
);
